export default {
  isAnonymous: true,
  error: null,
  loaded: false,
};
